import {
  REQUEST_USERSTATISTICS,
  REQUEST_USERSTATISTICS_DONE,
  UserStatisticsActions
} from "./types";
import { UserStatistics } from "../../../models/Statistics";
import * as StatisticsApi from "../../../api/statisticsApi";
import { isOk } from "../../../result";

function fetchUserStatistics(): UserStatisticsActions {
  return {
    type: REQUEST_USERSTATISTICS,
    payload: []
  };
}

function fetchUserStatisticsDone(
  UserStatistics: ReadonlyArray<UserStatistics>
): UserStatisticsActions {
  return {
    type: REQUEST_USERSTATISTICS_DONE,
    payload: UserStatistics
  };
}

/* Thunks goes here */
export const thunkFetchUserStatistics = (
  periodFrom: Date,
  periodTo: Date
) => async (dispatch: any) => {
  try {
    dispatch(fetchUserStatistics());
    const result = await StatisticsApi.getUserStatistics(periodFrom, periodTo);

    if (isOk(result)) {
      dispatch(fetchUserStatisticsDone(result.value));
    } else {
      console.log(result.details);
      dispatch(fetchUserStatisticsDone([]));
    }
  } catch (error) {
    console.log(error);
  }
};
